export default "__VITE_ASSET__oCzjPv0Q__"